import { useUserData } from '../../../../hooks'
import { isDwellerRole } from '../../../../utils/user'
import { TaskTableRow } from '../../../Task'
import { useRequestProfileContext } from '../../RequestProfile.hooks'

import { renderCell } from './RequestProfileTabActivitiesTableRow.utils'

import * as styles from './RequestProfileTabActivitiesTableRow.module.css'

function RequestProfileTabActivitiesTableRow({
  canEditActivities,
  onCallAction,
  ...props
}) {
  const currentUser = useUserData()

  const { outboundUuid } = useRequestProfileContext()

  const hideAutomationsTag = isDwellerRole(currentUser) || Boolean(outboundUuid)

  function renderActivityCell(cellProps) {
    return renderCell({
      ...cellProps,
      canEditActivities,
      emptyCellClassName: styles.emptyCell,
      hideAutomationsTag,
      titleTextClassName: styles.titleText,
      onCallAction,
    })
  }

  return <TaskTableRow {...props} renderCell={renderActivityCell} />
}

export default RequestProfileTabActivitiesTableRow
